<template>
  <router-view />
</template>

<script>
export default {
  name: "SampleResultsNest"
};
</script>
